import { TextareaHTMLAttributes } from "react"
import { useFormContext } from "react-hook-form"
import Field from "./Field"
import clsx from "clsx"

interface TextAreaProps {
  name: string
  label?: string
  className?: string
}

const TextArea = ({
  name,
  label,
  className = "w-full px-2 border-2 border-gray-900 rounded outline-none focus:border-teal-500",
  ...rest
}: TextAreaProps & TextareaHTMLAttributes<HTMLTextAreaElement>) => {
  const {
    register,
    formState: { errors },
  } = useFormContext()

  return (
    <Field label={label} name={name} errors={errors}>
      <textarea
        id={name}
        className={clsx(className)}
        {...register(name)}
        {...rest}
      />
    </Field>
  )
}

export default TextArea
